import { is } from "bpmn-js/lib/util/ModelUtil";
import type EventBus from "diagram-js/lib/core/EventBus";
import BaseRenderer from "diagram-js/lib/draw/BaseRenderer";
import type { ElementLike, Shape } from "diagram-js/lib/model/Types";
import { HIGH_PRIORITY } from "../helpers";

export default class LaneLabelRenderer extends BaseRenderer {
    bpmnRenderer: BaseRenderer;

    constructor(eventBus: EventBus, bpmnRenderer: BaseRenderer) {
        super(eventBus, HIGH_PRIORITY);
        this.bpmnRenderer = bpmnRenderer;

        eventBus.on<Event & { element: ElementLike }>(
            "element.dblclick",
            HIGH_PRIORITY,
            function ({ element }) {
                if (is(element, "bpmn:Lane")) {
                    // Cancel edit for lane labels
                    return false;
                }
            }
        );
    }

    canRender(element: ElementLike) {
        return is(element, "bpmn:Lane");
    }

    drawShape(visuals: SVGElement, shape: Shape): SVGElement {
        // Add a class to the parent so it can be hidden with CSS.
        visuals.classList.add("djs-lane");

        return this.bpmnRenderer.drawShape(visuals, shape);
    }
}

LaneLabelRenderer.$inject = ["eventBus", "bpmnRenderer"];
